export const FETCH_USER_LIST = "FETCH_USER_LIST";
export const FETCH_ALL_USER_LIST = "FETCH_ALL_USER_LIST";
export const FETCH_USER_AGENTS_LIST = "FETCH_USER_AGENTS_LIST";
export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
